import { styled } from 'styled-components';
import matchboxClosedImg from '../assets/optimized/matchbox-closed.webp';
import matchboxOpenImg from '../assets/optimized/matchbox-open.webp';

export default function Matchbox() {
    return (
        <MatchboxContainer>
            <MatchHeads src={matchboxOpenImg} alt="Match heads" />
            <BoxImage src={matchboxClosedImg} alt="Matchbox" />
        </MatchboxContainer>
    );
}

const MatchboxContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

const BoxImage = styled.img`
    position: relative;
    width: 100%;
    height: 100%;
`;

const MatchHeads = styled.img`
    position: absolute;
    right: 3%;
    width: 100%;

    @media (max-width: 768px) {
        top: -1%;
        height: 93%;
    }
    @media (min-width: 768px) {
        top: 2%;
        height: 91%;
    }

    transform: translateX(calc(-15% * (1 - var(--is-hovered, 0))));
    @media (max-width: 768px) {
        /* Mobile: default to ~50% of the desktop hover reveal */
        transform: translateX(calc(-15% * 0.15 * (1 - var(--is-hovered, 0))));
    }
    transition: transform 300ms ease;

    /* for better performance */
    /* practically, prevents shadow jitter */
    will-change: transform; 
    
    pointer-events: none;
`;

